import { render, staticRenderFns } from "./DDJBAuthorization.vue?vue&type=template&id=d3b7d1ac&scoped=true"
import script from "./DDJBAuthorization.vue?vue&type=script&lang=js"
export * from "./DDJBAuthorization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3b7d1ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d3b7d1ac')) {
      api.createRecord('d3b7d1ac', component.options)
    } else {
      api.reload('d3b7d1ac', component.options)
    }
    module.hot.accept("./DDJBAuthorization.vue?vue&type=template&id=d3b7d1ac&scoped=true", function () {
      api.rerender('d3b7d1ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/allianceAuthorization/DDJBAuthorization.vue"
export default component.exports